import axios, { AxiosResponse } from 'axios';
import { ApiResponse } from '../api.types';
import { TimezoneResponse } from './google.types';

const getTimezone = async (lat: number, lng: number) => {
  const timestamp = new Date().getTime() / 1000;
  const { data }: AxiosResponse<TimezoneResponse> = await axios.get(
    'https://maps.googleapis.com/maps/api/timezone/json', {
      params:
        {
          location: `${lat},${lng}`,
          timestamp,
          key: window.config.googleApiKey
        }
    }
  );

  return data;
};

const GoogleApi = {
  Google: {
    getTimezone
  }
};

export default GoogleApi;
